module.exports = __webpack_public_path__ + "static/back-to-servicetitan-1d1e30ac709bb041052e7344922183a7.svg";